import React from 'react'
import TrainingDashboard from './TrainingDashboard';
import TrainingHistory from './TrainingHistory';
import './TrainingSection.css';

export default function TrainingSection() {
  return (
    <div className='training-section-container'>
        <TrainingDashboard />
        <TrainingHistory />
    
      
    </div>
  )
}
